<template>
    <div class="betshops__page-layout">
        <div class="betshops__page-layout--content">
            <SearchableSelect
                class="betshops__search-field"
                v-model="selectedShop"
                :availableOptions="shops"
                :placeholder="$t('shops') | capitalize"
                :nameField="['city', 'address']"
                @input="onSearchSelected"
            />
            <div class="betshops__map-container">
                <GoogleMap
                    :zoom="zoom"
                    :useNavigatorForDefaultLocation="true"
                    :defaultLocation="defaultLocation"
                    :markers="shops"
                    :selectedMarker="selectedShop"
                    @markerClick="onShopClick"
                    @zoomChanged="onZoomClick"
                    class="betshops__map"
                >
                    <template
                        slot="infoWindow"
                        slot-scope="slotProps"
                    >
                        <ShopInfo
                            :city="slotProps.selectedMarker.city"
                            :address="slotProps.selectedMarker.address"
                            :openingHour="slotProps.selectedMarker.openingHour"
                            :closingHour="slotProps.selectedMarker.closingHour"
                        />
                    </template>
                </GoogleMap>
            </div>
            <div class="betshops__page-content-wrapper">
                <div class="static-page__content betshops-page__content">
                    <SanitizedHtml :content="pageContent" />
                </div>
            </div>
        </div>
        <div class="betshops__page-layout--shops-list">
            <div class="betshops__page-layout--shops-list-wrapper">
                <div
                    v-show="!isMobile"
                    class="betshops__page-layout--shops-list-wrapper"
                >
                    <div class="x-jackpot-container">
                        <SanitizedHtml :content="content" ref="promoContent" />
                    </div>
                </div>
                <div class="betshops__shops-list--header">
                    {{ $t('agency locations') }}
                </div>
                <div
                    v-if="isLoadingShops"
                    class="betshops__loader-wrapper"
                >
                    <SpinnerBars/>
                </div>
                <ShopList
                    :shops="shops"
                    @shopListClick="onShopListClick"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import SanitizedHtml from '@modules/shared/components/SanitizedHtml.vue';
    import { wikiService } from '@core/services/wiki/WikiService';
    import config from '@config';
    import SearchableSelect from '@modules/shared/components/SearchableSelect.vue';
    import Logger from '@core/utils/loggers/Logger';
    import { errorGuard } from '@app/utils';
    import { isMobile } from '@app/layout';
    import XJackpotMixin from '@modules/wiki/components/XJackpotMixin';
    import ShopList from './components/ShopList';
    import ShopInfo from './components/ShopInfo';

    const BANNER_CONTAINER = 'main-container';

    export default {
        name: 'ShopsContainer',
        mixins: [XJackpotMixin],
        data() {
            return {
                isLoadingShops: false,
                isLoading: false,
                selectedShop: undefined,
                pageContent: '',
                content: '',
                zoom: config.app.googleMaps.defaultZoom,
            };
        },
        watch: {
            selectedShop(newValue) {
                if (newValue) {
                    this.zoom = config.app.googleMaps.defaultZoom;
                }
            }
        },
        created() {
            this.isLoading = true;
            this.isLoadingShops = true;
            this.defaultLocation = config.app.googleMaps.defaultLocation;
            const loadMainContent = async () => {
                await errorGuard({
                    action: this.fetchJackpotBanner,
                });
                this.isLoading = false;
            };
            const loadJackpotBanner = async () => {
                await errorGuard({
                    action: async () => {
                        await Promise.all([
                            this.fetchShops(),
                            this.fetchPageContent(),
                        ]);
                    },
                });
                this.isLoadingShops = false;
            };
            loadMainContent();
            loadJackpotBanner();
        },
        mounted() {
            this.setupCounter();
        },
        computed: {
            ...mapGetters('data/country', [
                'shops',
            ]),
            isMobile() {
                return isMobile();
            },
        },
        methods: {
            ...mapActions('data/country', [
                'fetchShops',
            ]),
            async fetchPageContent() {
                try {
                    this.pageContent = await wikiService.getPage(this.$t('agencies-content'));
                } catch (e) {
                    // we wanna show the page nevertheless. User can still choose shops.
                    Logger.error(e);
                }
            },
            onShopClick(shop) {
                this.selectedShop = shop;
            },
            onZoomClick(value) {
                this.zoom = value;
            },
            onShopListClick(shop) {
                this.selectedShop = shop;
                this.$scrollTo({
                    container: null,
                    duration: config.app.scrollDuration,
                    offset: 0,
                });
            },
            onSearchSelected() {
                if (document.activeElement) {
                    document.activeElement.blur();
                }
            },
            async fetchJackpotBanner() {
                this.content = await wikiService.getPage('txj-0309');
            },
            async findXJackpotElements() {
                await this.$nextTick();
                if (!this.$refs.promoContent) {
                    return null;
                }

                const xJackpotContainer = this.$refs.promoContent.$el.querySelector(`.${BANNER_CONTAINER}`);
                return [xJackpotContainer];
            },
        },
        components: {
            SanitizedHtml,
            SearchableSelect,
            ShopList,
            ShopInfo,
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/country/shops/ShopsContainer.vue